import { tv } from 'tailwind-variants'

export interface TChipProps {
  variant: 'primary' | 'success' | 'warning' | 'danger'
  chip: 'new' | 'summary' | 'reminder' | 'one_off'
  size?: 'xs' | 'sm' | 'md'
}

export const chipLabel = (chip: TChipProps['chip']): string =>
  ({
    new: 'NEW',
    summary: 'SUMMARY',
    reminder: 'REMINDER',
    one_off: 'ONE OFF'
  })[chip]

export const chipVariants = tv({
  slots: {
    chipSlot:
      'flex items-center justify-center gap-2 rounded-full px-2 py-0.5 font-black leading-none'
  },
  variants: {
    variant: {
      primary: {
        chipSlot: 'bg-primary-200 text-surface-white-50'
      },
      success: {
        chipSlot: 'bg-success-200 text-surface-white-50'
      },
      warning: {
        chipSlot: 'bg-warning-200 text-surface-white-50'
      },
      danger: {
        chipSlot: 'bg-danger-200 text-surface-white-50'
      }
    },
    size: {
      xs: {
        chipSlot: 'text-[8px]'
      },
      sm: {
        chipSlot: 'text-[9px]'
      },
      md: {
        chipSlot: 'text-caption-sm'
      }
    }
  },
  defaultVariants: {
    size: 'md'
  }
})

export const Chip = ({ variant, chip, size }: TChipProps): JSX.Element => {
  const { chipSlot } = chipVariants({ variant, size })
  return <div className={chipSlot()}>{chipLabel(chip)}</div>
}
